
import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'frame'
import { constants } from './module'
import { Account, Profile, Security } from './components'

export const ModuleRoutes = () => (
  <Layout>
    <Routes>
      {/* Account shell (tabs) */}
      <Route path="/" element={<Account />}>
        <Route path={constants.REL_PROFILE} element={<Profile />} />
        <Route path={constants.REL_SECURITY} element={<Security />} />

        {/* Default + fallback */}
        <Route index element={<Navigate to={constants.REL_PROFILE} replace />} />
        <Route path="*" element={<Navigate to={constants.REL_PROFILE} replace />} />
      </Route>
    </Routes>
  </Layout>
)
